<template>
    <TransactionalScreen class="bg-light" :title="$t('resetPassword.title')" hideLogo clickableLogo @clickOnLogo="$router.push({ name: 'login' })" @setLanguage="setLanguage">

        <div class="mb-3">{{ $t('resetPassword.intro') }} {{ $store.state.name }}.</div>

        <FormRoot @submit="resetPassword" @keyup="form.keyUp()" class="form" v-if="!form.success">

            <!-- Password -->
            <Field
                :form.sync="form"
                :type="reveal ? 'text' : 'password'"
                name="password"
                :placeholder="$t('resetPassword.password')"
                :hint="$t('resetPassword.password_hint')"
                @input="clearErrors()"
                focus
            />
            <!-- / Password -->

            <a href="#" @click="reveal = !reveal" class="text-decoration-none"><Icon :icon="reveal ? 'eye-slash' : 'eye'" /> {{ reveal ? 'Hide' : 'Reveal' }} password</a>

            <!-- Submit -->
            <div class="text-center">
                <Button type="submit" color="primary" large class="mt-4" :disabled="!form.submittable || loading">{{ $t('resetPassword.submit') }}</Button>
            </div>
            <div class="mt-4"><router-link :to="{ name: 'login' }" class="text-muted"><Icon icon="angle-left"/> {{ $t('resetPassword.cancel') }}</router-link></div>
            <!-- / Submit -->

        </FormRoot>
        <div v-else>
            <Alert v-if="form.success.success" color="success" icon="check">{{ form.success.message }}</Alert>
            <Alert v-else color="warning" icon="exclamation-circle">{{ form.success.message }}</Alert>
            <div class="mt-3 text-center" v-if="loading">
                <Spinner />
            </div>
            <div class="mt-4" v-else>
                <router-link :to="{ name: 'login' }" class="text-muted"><Icon icon="angle-left" /> {{ $t('login.Back') }}</router-link>
                <router-link :to="{ name: 'login' }" class="text-muted float-end">{{ $t('login.Login') }} <Icon icon="angle-right" /></router-link>
            </div>
        </div>
    </TransactionalScreen>
</template>

<script>
    import { Form, Field, FormRoot, Button, Alert, TransactionalScreen, Spinner } from '@tech_hexeko/design-system'
    import {store} from "../../index";

    export default {
        data () {
            return {
                form: new Form({
                    password: null,
                    token: this.$route.params.token
                }),
                loading: false,
                reveal: false
            }
        },
        methods: {
            resetPassword() {
                this.loading = true

                // Reset password
                this.form.submit(() => {
                    return this.$api.authenticate.resetPassword(this.form.data())
                })
                    .then(() => {

                        // Get user e-mail
                        this.$api.authenticate.verify(this.form.token).then(user => {

                            // Login user
                            store.dispatch('auth/postLogin', {
                                email: user.email,
                                password: this.form.password
                            }).then(() => {
                                setTimeout(() => {
                                    this.loading = false
                                }, 3000);
                            })

                        })

                    });
            },
            clearErrors() {
                this.form.errors.clear()
                this.form.errors.clear('password')
                this.$forceUpdate()
            },
            setLanguage(lang) {
                store.dispatch('lang/setLanguage', lang)
            }
        },
        components: {
            Field,
            FormRoot,
            Button,
            Alert,
            TransactionalScreen,
            Spinner
        }
    }
</script>
